import { sharedColors } from "ui/theme/colors"

const colors = {
  ...sharedColors,
  blue4rentMarketing: "#1988E2",
  darkBlue4rentMarketing: "#1F375D",
  advantagesBg4rentMarketing: "#F3F9FE",
  bulletsBackgroundColor4rentMarketing: "#B5BFC9",
  bulletsBackgroundColor4rentMarketingActive: "#1988E2",
  gray4rentMarketing: "#868A90",
}

export default colors
